import { NAME } from "./constants";

const select = key => state => state.ui[NAME][key];

export const getCurrentView = select("name");
